import "./App.css";
import Weather from "./Weather";

export default function App() {
  return (
    <div className="body">
      <div className="App">
        <div className="container">
          <Weather defaultCity="New York" />
          <footer>
            This project was coded by Jena Stewart and is open-sourced on{" "}
            <a
              href="https://github.com/jenastewart/week5-reactWeatherApp"
              target="_blank"
              rel="noreferrer"
            >
              GitHub
            </a>{" "}
            and hosted on{" "}
            <a
              href="https://jenas-week5-react-weather-app.netlify.app/"
              target="_blank"
              rel="noreferrer"
            >
              Netlify
            </a>
          </footer>
        </div>
      </div>
    </div>
  );
}
